namespace TabAurous.OMS {
    export interface BrandMasterForm {
        AttributeTypeId: Serenity.IntegerEditor;
        BrandCode: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
    }

    export class BrandMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.BrandMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BrandMasterForm.init)  {
                BrandMasterForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(BrandMasterForm, [
                    'AttributeTypeId', w0,
                    'BrandCode', w1,
                    'BrandName', w1
                ]);
            }
        }
    }
}
